<template>
    <img :class="className" src="@static/images/product/pdf.png" v-if="checkFileType('.pdf')" />
    <img :class="className" src="@static/images/product/word.png" v-else-if="checkFileType('.doc')" />
    <img :class="className" src="@static/images/product/excel.png" v-else-if="checkFileType('.xls')" />
    <img :class="className" src="@static/images/product/video.png" v-else-if="checkFileType('.mp4')" />
    <img :class="className" src="@static/images/product/img.png" v-else-if="checkFileType(['.jpg','.png'])" />
</template>
<script>
export default {
  props: {
    className:null,
    url:null
  },
  data: () => ({
  }),
  components: {},
  created() {},
  methods: {
    // 验证文件类型
    checkFileType(type) {
      let url = this.url;
      if(!url) {
        return false;
      }
      if(typeof type == "string"){
        url = url.toLowerCase()
        if(url.includes(type)){
          return true;
        }
      }
      if(typeof type == "object"){
        const fileType = url.substring(url.lastIndexOf("\."));
        if(type.includes(fileType)){
          return true;
        }
      }
      return false;
    },
  }
};
</script>